const SET_TABLE_DATA = "GET_TABLE_DATA";
const SET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";
const SEARCH_QUERY = "SEARCH_QUERY";
const SORT_BY = "SORT_BY";
const PAGE_NO = "PAGE_NO";
const SET_LIMIT = "SET_LIMIT";
const SET_FILTER_OPTIONS = "SET_FILTER_OPTIONS";
const SET_FILTER_SAVED = "SET_FILTER_SAVED";
const DATE_FILTERS = "DATE_FILTERS";
const SEARCH_ON = "SEARCH_ON";

// eslint-disable-next-line import/prefer-default-export
export {
  SET_DASHBOARD_DATA,
  SEARCH_QUERY,
  SORT_BY,
  PAGE_NO,
  SET_LIMIT,
  SET_TABLE_DATA,
  SET_FILTER_SAVED,
  SET_FILTER_OPTIONS,
  DATE_FILTERS,
  SEARCH_ON
};
